export default __webpack_public_path__ + "static/media/GT-America-Standard-Regular.9d7f8515.woff2";